module.exports = __webpack_public_path__ + "img/restore.7c8928d1.png";